import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule, inject } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrSharedModule } from '@next/core-lib/shared';

import { CropAidModule } from '../crop-aid/crop-aid.module';
import { LegalRestrictionModule } from '../legal-restriction/legal-restriction.module';
import { EnvironmentalImpactTableComponent } from './components/environmental-impact-table/environmental-impact-table.component';
import { FertilizationTableComponent } from './components/fertilization-table/fertilization-table.component';
import { GrainRegistrationReminderDialogComponent } from './components/grain-registration-reminder-dialog/grain-registration-reminder-dialog.component';
import { NutrientBalanceTableComponent } from './components/nutrient-balance-table/nutrient-balance-table.component';
import { OrganicMatterTableComponent } from './components/organic-matter-table/organic-matter-table.component';
import { NgxtForDirective } from './directives/ngtx.directive';

@NgModule({
  declarations: [
    // add shared components here
    FertilizationTableComponent,
    GrainRegistrationReminderDialogComponent,
    OrganicMatterTableComponent,
    NutrientBalanceTableComponent,
    EnvironmentalImpactTableComponent,
    NgxtForDirective,
  ],
  imports: [
    // StoreModule.forRoot({}),
    // EffectsModule.forRoot([]),
    LegalRestrictionModule,
    CropAidModule,
    ScrollingModule,
    AgrSharedModule,
    MatTableModule,
    MatIconModule,
    AgrDialogModule,
],
  exports: [
    AgrSharedModule,
    // add shared modules here
    FertilizationTableComponent,
    GrainRegistrationReminderDialogComponent,
    OrganicMatterTableComponent,
    NutrientBalanceTableComponent,
    EnvironmentalImpactTableComponent,
  ],
  providers: [
    // add shared services and guards here
    // ApiService,
  ],
})
export class SharedModule {
  constructor() {
    const matIcon = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    matIcon.addSvgIconLiteral(
      'compost-settings',
      sanitizer.bypassSecurityTrustHtml(
        /* eslint-disable max-len */
        '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path fill="currentColor" d="M480-100q-79 0-148-30t-120.5-81.5Q160-263 130-332t-30-148q0-79 30-148t81.5-120.5Q263-800 332-830t148-30v-100l160 160-160 160v-100q-108 0-184 76t-76 184q0 66 30.5 122.5T332-266q16-28 47.5-47.5T452-338q-3-21-8-42t-12-39q-11 9-24 14t-28 5q-33 0-56.5-23.5T300-480v-40q0-17-5.5-32T280-580q50-1 89 9 34 9 62 29.5t29 61.5q0 9-1.5 16.5T453-448q-13-10-26-18t-27-14q17 13 39 40t41 64q20-49 50-96.5t70-87.5q-23 16-44 34t-41 38q-7-11-11-24.5t-4-27.5q0-42 29-71t71-29h40q23 0 38-6t25-14q11-9 17-20 4 67-7 120-9 45-34 82.5T600-440q-15 0-28.5-4T547-455q-7 19-16 50.5T517-337q38 7 67 26t44 45q51-35 81.5-91T740-480h120q0 79-30 148t-81.5 120.5Q697-160 628-130t-148 30Z"/></svg>',
      ),
    );
    matIcon.addSvgIconLiteral(
      'warehouse-settings',
      sanitizer.bypassSecurityTrustHtml(
        /* eslint-disable max-len */
        '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path fill="currentColor"d="M160-200h80v-320h480v320h80v-426L480-754 160-626v426Zm-80 80v-560l400-160 400 160v560H640v-320H320v320H80Zm280 0v-80h80v80h-80Zm80-120v-80h80v80h-80Zm80 120v-80h80v80h-80ZM240-520h480-480Z"/></svg>',
      ),
    );
    matIcon.addSvgIconLiteral(
      'convert-to-text',
      sanitizer.bypassSecurityTrustHtml(
        /* eslint-disable max-len */
        '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path fill="currentColor"d="M400-280h160v-80H400v80Zm0-160h280v-80H400v80ZM280-600h400v-80H280v80Zm200 120ZM80-80v-80h102q-48-23-77.5-68T75-330q0-79 55.5-134.5T265-520v80q-45 0-77.5 32T155-330q0 39 24 69t61 38v-97h80v240H80Zm320-40v-80h360v-560H200v160h-80v-160q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H400Z"/></svg>',
      ),
    );
    matIcon.addSvgIconLiteral(
      'balance',
      sanitizer.bypassSecurityTrustHtml(
        /* eslint-disable max-len */
        '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"/></g><g><path d="M13,7.83c0.85-0.3,1.53-0.98,1.83-1.83H18l-3,7c0,1.66,1.57,3,3.5,3s3.5-1.34,3.5-3l-3-7h2V4h-6.17 C14.42,2.83,13.31,2,12,2S9.58,2.83,9.17,4L3,4v2h2l-3,7c0,1.66,1.57,3,3.5,3S9,14.66,9,13L6,6h3.17c0.3,0.85,0.98,1.53,1.83,1.83 V19H2v2h20v-2h-9V7.83z M20.37,13h-3.74l1.87-4.36L20.37,13z M7.37,13H3.63L5.5,8.64L7.37,13z M12,6c-0.55,0-1-0.45-1-1 c0-0.55,0.45-1,1-1s1,0.45,1,1C13,5.55,12.55,6,12,6z"/></g></svg>',
      ),
    );
  }
}
